import { render, staticRenderFns } from "./FreeTime.vue?vue&type=template&id=eca2f0c8&scoped=true"
import script from "./FreeTime.vue?vue&type=script&lang=js"
export * from "./FreeTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eca2f0c8",
  null
  
)

export default component.exports